
/* Velvet Search - fase 1.1
   LPOS-sortering, quick-buy en sluitgedrag
*/
(() => {
  if (window.__velvetSearchEnhancements) return;
  window.__velvetSearchEnhancements = true;

  function dateNumber(input) {
    if (!input) return 0;
    const value = String(input).trim();

    let match = value.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})/);
    if (match) {
      return Number(match[1]) * 10000 +
        Number(match[2]) * 100 + Number(match[3]);
    }

    match = value.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})/);
    if (match) {
      return Number(match[3]) * 10000 +
        Number(match[2]) * 100 + Number(match[1]);
    }

    return 0;
  }

  function sortProducts(container) {
    const list = container.querySelector('.velvet-search-products');
    if (!list) return;

    const products = Array.from(
      list.querySelectorAll(':scope > .velvet-search-product')
    );

    products.sort((a, b) => {
      const aStock = Number(a.dataset.velvetStock || 0) > 0 ? 1 : 0;
      const bStock = Number(b.dataset.velvetStock || 0) > 0 ? 1 : 0;

      if (aStock !== bStock) return bStock - aStock;

      return dateNumber(b.dataset.velvetRelease) -
        dateNumber(a.dataset.velvetRelease);
    });

    products.forEach((product) => list.appendChild(product));
  }

  function rootPath() {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  }

  // Sluit de dropdown, maar behoud de zoekterm.
  function closeDropdown(widget) {
    if (typeof widget.close === 'function') widget.close();

    // Ruim ook de keyup-listener van Enterprise op.
    if (widget.keyupHandler) {
      widget.removeEventListener('keyup', widget.keyupHandler);
    }

    widget.removeAttribute('results');
  }

  async function handleQuickAdd(event) {
    const button = event.target.closest('.velvet-search-add');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.disabled) return;

    const variantId = Number(button.dataset.velvetVariantId);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) return;

    const oldLabel = button.textContent.trim();
    button.disabled = true;
    button.textContent = 'Bezig…';

    try {
      const response = await fetch(`${rootPath()}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Toevoegen is niet gelukt'
        );
      }

      button.textContent = '✓ Toegevoegd';

      try {
        const cartResponse = await fetch(
          `${rootPath()}cart.js`,
          { cache: 'no-store' }
        );

        if (cartResponse.ok) {
          const cart = await cartResponse.json();

          document.querySelectorAll(
            '[data-cart-count], .cart-count, .header__cart-count'
          ).forEach((el) => {
            if (el.childElementCount === 0) {
              el.textContent = String(cart.item_count);
            }
          });

          document.dispatchEvent(
            new CustomEvent('velvet:cart:updated', {
              bubbles: true,
              detail: { cart }
            })
          );
        }

        document.dispatchEvent(
          new CustomEvent('dispatch:cart-drawer:refresh', {
            bubbles: true
          })
        );
      } catch (cartUiError) {
        console.warn(
          'Velvet Search: winkelwagen bijgewerkt, maar UI-refresh niet volledig:',
          cartUiError
        );
      }

    } catch (error) {
      console.error('Velvet Search: toevoegen mislukt:', error);
      button.textContent = 'Niet gelukt';
      button.title = error.message || 'Kan dit product niet toevoegen';

    } finally {
      window.setTimeout(() => {
        if (button.isConnected) {
          button.disabled = false;
          button.textContent = oldLabel;
        }
      }, 1900);
    }
  }

  function init() {
    document.querySelectorAll('predictive-search').forEach((widget) => {
      const results = widget.querySelector('.js-search-results');
      const input = widget.querySelector('.js-search-input');
      const form = widget.querySelector('form.search');

      if (
        !results ||
        !input ||
        !form ||
        results.dataset.velvetInitialized === 'true'
      ) return;

      results.dataset.velvetInitialized = 'true';

      results.addEventListener('click', handleQuickAdd);

      // Koopknoppen afzonderlijk met toetsenbord bedienen.
      results.addEventListener('keydown', (event) => {
        if (event.target.closest('.velvet-search-add')) {
          event.stopPropagation();
        }
      });

      // ENTER = volledige zoekpagina openen.
      input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.isComposing) return;

        widget.dataset.velvetLeaving = 'true';
        closeDropdown(widget);

        // Voorkom dat Enterprise een geselecteerd
        // dropdownproduct opent in plaats van de zoekpagina.
        event.stopPropagation();

        // Geen preventDefault:
        // het zoekformulier moet normaal verzonden worden.
      });

      // Ook bij klikken op de zoekknop sluiten.
      form.addEventListener('submit', () => {
        widget.dataset.velvetLeaving = 'true';
        closeDropdown(widget);
      }, true);

      // Dropdown sluiten wanneer op een resultaat wordt geklikt.
      results.addEventListener('click', (event) => {
        if (!event.target.closest('a[href]')) return;

        widget.dataset.velvetLeaving = 'true';
        closeDropdown(widget);
      });

      // Nieuwe invoer activeert de dropdown weer.
      input.addEventListener('input', () => {
        delete widget.dataset.velvetLeaving;
      });

      // Sorteer iedere nieuwe set zoekresultaten.
      const observer = new MutationObserver(() => {
        if (widget.dataset.velvetLeaving === 'true') {
          if (widget.hasAttribute('open')) {
            closeDropdown(widget);
          }
          return;
        }

        sortProducts(results);
      });

      observer.observe(results, { childList: true });
      sortProducts(results);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  // Voorkom een open dropdown bij terugnavigeren.
  window.addEventListener('pageshow', (event) => {
    document.querySelectorAll('predictive-search').forEach((widget) => {
      delete widget.dataset.velvetLeaving;

      if (event.persisted && widget.hasAttribute('open')) {
        closeDropdown(widget);
      }
    });
  });
})();
